// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons__7boBN","eye":"styles_eye__N2tRI","tooltip":"styles_tooltip__YcY22","tooltipArrow":"styles_tooltipArrow__K1720","tooltipContent":"styles_tooltipContent__Dbshc"};